define([], function () {
	if (!window.ERV || !window.ERV.ConfigurationSettings) {
		console.warn('Could not load ConfigurationSettings');
		return {};
	}
	return window.ERV.ConfigurationSettings;
});